import React from 'react';

import ContainerModal from '../ContainerModal';
import Button from '../Button';

const firstMedicalAppointmentImage =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/first-medical-appointment.svg';
const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';

import { ModalRuleValidation } from '../../modules/validateRules';

import { Container } from './styles';
import { useGenericModals } from '../../store/genericModals';
import { findGenericModal } from '../../utils/genericModals';
import { INFO_GENERIC_RULES_ACTION } from '../../utils/constants';

const MODAL_ICON: { [x: string]: any } = {
  is_first_appointment: firstMedicalAppointmentImage,
  always: firstMedicalAppointmentImage,
  schedule_consult: firstMedicalAppointmentImage,
  professional_without_schedule_available: warningIcon,
  professionals_without_schedule_available_first_consult: warningIcon,
  professionals_without_schedule_available_return: warningIcon,
  diu_professional_without_schedule_available: warningIcon,
  open_whatsapp: warningIcon,
  unavailable_slots: warningIcon
};

export type ModalGenericRulesProps = {
  visible: boolean;
  isVisible: (value: boolean) => void;
  handleActionButton?: (actionButton: string, data: any) => void;
  when: string;
  condition: string;
  onCloseModal?: () => void;
};

function ModalIcon({ icon, modalType }: { icon?: string; modalType?: string }) {
  if (icon) return <img src={icon} alt="modal illustration" />;
  if (modalType) return <img src={MODAL_ICON[modalType]} alt="image" />;
  return null;
}

export const ModalGenericRules: React.FC<ModalGenericRulesProps> = ({
  visible,
  isVisible,
  when,
  handleActionButton,
  condition,
  onCloseModal
}) => {
  const { genericModals } = useGenericModals();

  const [modalProps, setModalProps] = React.useState<ModalRuleValidation | null>(null);
  const [modalType, setModalType] = React.useState('');

  function handleOpenModal() {
    isVisible(true);
  }

  function handleCloseModal() {
    isVisible(false);
    onCloseModal && onCloseModal();
  }

  function checkCloseAction(actionButton: string | undefined) {
    if (actionButton === INFO_GENERIC_RULES_ACTION.CLOSE_MODAL && onCloseModal) onCloseModal();
  }

  function clickButtonSecondary(modalProps: ModalRuleValidation) {
    checkCloseAction(modalProps?.second_button?.action);
    handleActionButton &&
      modalProps.second_button &&
      handleActionButton(modalProps.second_button.action || '', modalProps.second_button.value);
  }

  function clickButtonPrimary(modalProps: ModalRuleValidation) {
    checkCloseAction(modalProps?.primary_button?.action);
    handleActionButton &&
      modalProps.primary_button &&
      handleActionButton(modalProps.primary_button.action || '', modalProps.primary_button.value);
  }

  React.useEffect(() => {
    if (when && condition && visible) {
      const infoToShow = genericModals
        ? findGenericModal({ when, condition, genericModals: genericModals })
        : undefined;

      if (infoToShow?.content) {
        setModalType(infoToShow.trigger.condition);
        setModalProps(infoToShow.content);
      }

      if (!infoToShow?.content) {
        setModalProps(null);
        handleCloseModal();
        console.error(`Modal (when:${when} | condition: ${condition}) not configured.`);
      }
    }
  }, [genericModals, visible, condition]);

  return (
    <ContainerModal
      visible={visible}
      onClose={handleCloseModal}
      withoutCloseButton
      childrenFooter={
        modalProps && (
          <>
            {modalProps.primary_button && (
              <Button
                disabled={!visible}
                type="button"
                title={modalProps.primary_button.text || 'Confirmar'}
                onClick={() => clickButtonPrimary(modalProps)}
              />
            )}
            {modalProps.second_button && (
              <Button
                disabled={!visible}
                type="button"
                title={modalProps.second_button.text || 'Cancelar'}
                onClick={() => clickButtonSecondary(modalProps)}
                tertiary
              />
            )}
          </>
        )
      }
    >
      {modalProps && (
        <Container>
          <ModalIcon icon={modalProps.icon} modalType={modalType} />
          <h3 className="title">{modalProps.title}</h3>
          <p className="subtitle" dangerouslySetInnerHTML={{ __html: modalProps.body }}>
            {/* {modalProps.body} */}
          </p>
        </Container>
      )}
    </ContainerModal>
  );
};
